<div class="flex flex-col gap-2">
	<ui-input
		appKeyboard
		class="w-full [&_.ui-input-shell]:min-h-11! [&_input]:[direction:ltr]"
		labelPosition="inside"
		[id]="'order-value'"
		[label]="labels.title"
		[step]="100"
		[stepValue]="100"
		[readOnly]="true"
		[ngModel]="formattedValue()"
		(ngModelChange)="onValueInput($event)">
		<div class="flex items-center gap-0.5 -ms-1.5" dir="ltr">
			<div class="inline-flex min-w-16 flex-col items-stretch gap-0.5 ps-px">
				<div
					role="button"
					class="flex h-4.5 cursor-pointer items-center justify-start gap-0.5 rounded-sm rounded-tl-md bg-gray-950/10 px-px text-2.75 font-medium leading-none text-gray-700"
					(click)="onMaxClick()">
					<ui-icon
						class="inline-flex shrink-0 items-center justify-center"
						width="16"
						height="16"
						iconName="chevron-up"
						color="text-gray-500" />
					<span class="inline-flex items-center leading-none whitespace-nowrap">{{ labels.max }}</span>
				</div>
				<div
					role="button"
					class="flex h-4.5 cursor-pointer items-center justify-start gap-0.5 rounded-sm rounded-bl-md bg-gray-950/10 px-px text-2.75 font-medium leading-none text-gray-700"
					(click)="onMinClick()">
					<ui-icon
						class="inline-flex shrink-0 items-center justify-center"
						width="16"
						height="16"
						iconName="chevron-down"
						color="text-gray-500" />
					<span class="inline-flex items-center leading-none whitespace-nowrap">{{ labels.min }}</span>
				</div>
			</div>
		</div>
	</ui-input>

	<div
		role="group"
		dir="ltr"
		class="relative mx-1 min-h-6 select-none py-3"
		[class.opacity-60]="sliderLocked()"
		[attr.aria-disabled]="sliderLocked()"
		[attr.aria-label]="labels.title">
		<!-- Shared inset so thumb, fill, ticks, and tooltip share the same horizontal scale -->
		<div class="relative mx-2 h-5">
			<input
				type="range"
				class="order-calculator-range-input absolute inset-x-0 top-1/2 z-2 h-5 w-full -translate-y-1/2 appearance-none bg-transparent outline-none"
				min="0"
				max="100"
				step="1"
				[value]="sliderPercent()"
				[disabled]="sliderLocked()"
				[class.pointer-events-none]="sliderLocked()"
				[class.cursor-pointer]="!sliderLocked()"
				[class.cursor-not-allowed]="sliderLocked()"
				[attr.aria-disabled]="sliderLocked()"
				[attr.aria-valuemin]="0"
				[attr.aria-valuemax]="100"
				[attr.aria-valuenow]="sliderPercent()"
				[attr.aria-valuetext]="sliderPercent() + '%'"
				(input)="onSliderInput($event)"
				(pointerdown)="onSliderPointerDown()"
				(pointerup)="onSliderPointerUp()"
				(pointercancel)="onSliderPointerUp()"
				(mouseenter)="onSliderHover(true)"
				(mouseleave)="onSliderHover(false)" />

			<div
				class="pointer-events-none absolute inset-x-0 top-1/2 z-1 h-0.5 -translate-y-1/2 rounded-sm bg-gray-300"
				aria-hidden="true">
				<div
					class="absolute inset-y-0 inset-s-0 rounded-sm bg-gray-700"
					[style.width.%]="sliderPercent()"></div>
				@for (tick of sliderTicks; track tick) {
					<span
						class="absolute top-1/2 h-1.5 w-0.5 -translate-x-1/2 -translate-y-1/2 rounded-sm bg-gray-300"
						[class.bg-gray-500]="sliderPercent() >= tick"
						[style.left.%]="tick"></span>
				}
			</div>

			@if (sliderTooltipVisible()) {
				<div
					class="pointer-events-none absolute top-0 z-3 -translate-x-1/2"
					aria-hidden="true"
					[style.left.%]="sliderPercent()"
					[style.top.%]="-100">
					<span
						class="relative inline-block whitespace-nowrap rounded bg-gray-700 px-1.5 py-0.5 text-2.75 font-medium leading-tight text-gray-000 after:absolute after:inset-s-1/2 after:top-full after:-translate-x-1/2 after:border-4 after:border-transparent after:border-t-gray-700">
						{{ sliderPercent() }}%
					</span>
				</div>
			}
		</div>

		@if (sliderLocked()) {
			<div
				class="absolute inset-0 z-3 cursor-not-allowed"
				role="presentation"
				(pointerdown)="onLockedSliderInteraction($event)"></div>
		}
	</div>
</div>
